import { DOWNLOAD_MANAGER_INITIAL_STATE } from './constants'

const reducer = (data: object, newData: object): object => {
  if (newData === null) {
    return DOWNLOAD_MANAGER_INITIAL_STATE
  }
  return { ...data, ...newData }
}

export default reducer
